import {
    init as init_logging,
    log_history,
    log_history_to_string_array,
} from "@cling/lib.shared.logging"
import {default_logger} from "@cling/lib.shared.logging/default_logger"
import {safe_local_storage} from "@cling/lib.web.utils/safe_storage"
import {install_global_error_handler} from "@cling/lib.shared.debug"

/** Provided by build.client.web_app.ts */
declare const process: {
    env: {
        NODE_ENV: "development" | "test" | "production"
        VERSION: string
        F_PRINT_TO_CONSOLE: boolean
        F_PUBLIC: boolean
    }
}

export function init() {
    install_global_error_handler()
    init_logging(
        default_logger({
            log_history,
            print_to_console:
                process.env.F_PRINT_TO_CONSOLE || safe_local_storage.getItem("__debug"),
        }),
    )
    cling.debug = () => {
        // eslint-disable-next-line no-console
        log_history_to_string_array(log_history).forEach((line) => console.log(line))
        cling.print_to_console = true
        safe_local_storage.setItem("__debug", "1")
    }
    cling.log_history = () => log_history_to_string_array(log_history)
}
